export const SALE_MIN = 1;
export const SALE_MAX = 90;

export const saleDiscountError = (data) => {
  if (!data?.on_sale) return "";
  const n = Number(data.sale_discount);
  if (!Number.isInteger(n) || n < SALE_MIN || n > SALE_MAX) {
    return `Sale discount must be a whole number from ${SALE_MIN} to ${SALE_MAX}`;
  }
  return "";
};

export const salePrice = (rate, discount) => {
  const r = Number(rate);
  const d = Number(discount);
  if (!(r > 0) || !(d > 0)) return null;
  return Math.round(r - (r * d) / 100);
};

export const appendSale = (fdata, data) => {
  if (typeof data.on_sale !== "boolean") return;
  fdata.append("on_sale", data.on_sale ? "true" : "false");
  if (data.on_sale) fdata.append("sale_discount", data.sale_discount);
};
